<div class="breadcrumbbg">
  <div class="container">
    <H1 *ngIf="!isLoading">{{ title }}</H1>
    <nav aria-label="breadcrumb">
      <div *ngIf="isLoading" class="d-flex justify-content-center">
        <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
      </div>
      <p *ngIf="!isLoading">Você está em:&nbsp;&nbsp;</p>

      <ol class="breadcrumb" *ngIf="!isLoading && usuario">
        <li class="breadcrumb-item">
          <a href="/"><i class="fas fa-home"></i></a>
        </li>
        <li *ngFor="let menuItem of menuItems" class="breadcrumb-item">
          <a>{{ menuItem.nomeExibicao }}</a>
        </li>
      </ol>

      <ol class="breadcrumb" *ngIf="!isLoading && !usuario">
        <li class="breadcrumb-item" >
          <a [href]="external.retorno">{{external.desc}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
      </ol>
    </nav>
  </div>
</div>
